export const triggerBrowserDownloadFile = (blob: Blob, filename: string): void => {
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = blobUrl;
  anchor.download = filename;
  anchor.style.display = 'none';

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  URL.revokeObjectURL(blobUrl);
};

export const downloadFile = async (url: string, filename: string): Promise<void> => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Error fetching file: ${response.statusText}`);
  }

  const blob = await response.blob();

  triggerBrowserDownloadFile(blob, filename);
};
